import { Toolbar as MUIToolbar, ToolbarProps } from "@mui/material";

type Props = ToolbarProps;

export function Toolbar({ children, ...props }: Props) {
  return <MUIToolbar {...props}>{children}</MUIToolbar>;
}
